import type { RepeatWithSeat } from "../../hooks/api/useReservations";
import { RecurringRuleCard } from "./RecurringRuleCard";

interface RecurringReservationsSectionProps {
  repeats: RepeatWithSeat[];
  onCancelAll: (repeat: RepeatWithSeat) => void;
}

export function RecurringReservationsSection({
  repeats,
  onCancelAll,
}: RecurringReservationsSectionProps) {
  if (repeats.length === 0) {
    return (
      <div className="flex flex-col items-center gap-4 py-12 text-gray-500">
        <svg
          className="h-12 w-12 text-gray-300"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3"
          />
        </svg>
        <p>リピート予約はありません</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {repeats.map((repeat) => (
        <RecurringRuleCard
          key={repeat.repeatId}
          repeat={repeat}
          onCancelAll={onCancelAll}
        />
      ))}
    </div>
  );
}
